import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, PatientOutConfirmationAliases } from '../../codegen';
import BaseController from '../BaseController';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import { FormAPI, PanelAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { BrokerService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { Inject } from '@odinjs/odin';
import { ToastMsgUtils } from '../../utils/toastmsg-utils';

@Controller({ component: PatientOutConfirmationAliases.LAYOUT_MAIN, fragment: FragmentNames.PATIENT_OUT_CONFIRMATION })
class PatientOutConfirmationController extends BaseController {

  @Inject(PatientOutConfirmationAliases.TEXT_ATENDIMENTO)
  private readonly encounterId!: TextAPI;

  @Inject(PatientOutConfirmationAliases.TEXT_DESTINO)
  private readonly destination!: TextAPI;

  @Inject(PatientOutConfirmationAliases.FORM_FIELDS)
  private readonly formFields!: FormAPI;

  @Inject(PatientOutConfirmationAliases.PANEL_LOADER)
  private readonly panelLoaderApi!: PanelAPI;

  @OnMount({ target: PatientOutConfirmationAliases.LAYOUT_MAIN })
  onMountInput(): void {
    this.mountInformationBar();
  }

  @OnClick({target: PatientOutConfirmationAliases.BUTTON_CONFIRM })
  async onClickConfirm(): Promise<void> {
    this.panelLoaderApi.setVisible(true);
    const nrSeqLocalPa: number = this.context.get('sector') as number;
    try {
      const parameters = {
        departmentEncounter: nrSeqLocalPa,
        encounterId: this.historyService.getCurrentRouteParams().encounterId,
        generate: 'S',
        reasonCode: 0,
      };
      const resp = await HttpService.get(
        Endpoint.GENERATE_TRANSFER_CONFIRMATION,
        parameters
      );
      const responseBody = resp.body as { STATUS: string };
      if (responseBody.STATUS === 'NOK1') {
        ToastMsgUtils.toastErrorMessage('text.message-alert-attention', 'text.sector_exit_exists');
        return;
      }

      if (responseBody.STATUS === 'SUCESS1') {
        this.showModalSubmit();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.panelLoaderApi.setVisible(false);
    }
  }

  @OnMount({ target: PatientOutConfirmationAliases.FORM_FIELDS })
  onMountLayout(): void {
    this.inputFieldValues();
  }

  @OnClick({ target: PatientOutConfirmationAliases.BUTTON_CANCEL })
  onButtonClick(): void {
    applicationContext.popNavigationItem();
  }

  private inputFieldValues(): void {
    BrokerService.publishToTopic('setInformationBarData', this.context);
    BrokerService.publishToTopic('setChangeData', this.context);
    const { encounterId } = this.historyService.getCurrentRouteParams() as Record<string, string>;
    this.destination.setValue(this.context.get('department') as string);
    this.encounterId.setValue(encounterId);
    this.formFields.setLoading(false);
  }

  private showModalSubmit(): void {
    ToastMsgUtils.toastSucessMessage('msg.success', 'text.out_patient_ok');
    applicationContext.popNavigationItem();
  }

  private mountInformationBar(): void {
    const { patientId, encounterId } =
      this.historyService.getCurrentRouteParams();
    InformationBarUtils.collapsedBar = true;
    InformationBarUtils.allowInfo = true;
    this.context.set({
      encounterId,
      patientId,
    });
  }
}

export default PatientOutConfirmationController;
